import React from 'react';
import './CustomDropdownContainer.scss';

export const CustomDropdownContainer = ({ children, label }) => (
    <div className={'custom-dropdown'}>
        <span className={'dropdown-label'}>{label}</span>
        {children}
    </div>
);
